<ng-container [ngSwitch]="getProductionType()">
  <feature-page-layout-layout-two *ngSwitchCase="productionTypes.isIndustrialCam">
    <router-outlet></router-outlet>
  </feature-page-layout-layout-two>
  <feature-page-layout-layout-one *ngSwitchCase="productionTypes.isPolice"><router-outlet></router-outlet></feature-page-layout-layout-one>
</ng-container>
<feature-page-layout-google-maps></feature-page-layout-google-maps>
